// extracted by mini-css-extract-plugin
export default {"root":"LxPuuiTJ","list":"Eml6INN5"};